import { useContext, useEffect, useState } from "react";
import { calculateDateDifferenceInDays, formatDateWithArabicMonth, formatGregorianDate, formatPersianDate } from "../utils/date";
import { LocaleContext } from "../routing/LangRouter";

const useHeaderInfo = (type, information) => {
    const { locale } = useContext(LocaleContext);
    const [headerTitle, setHeaderTitle] = useState("");
    const [headerDetails, setHeaderDetails] = useState("");

    //format date in Persian format
    const formatDate = date => {
        return formatPersianDate(date, {
            day: "numeric",
            month: "long",
            year: undefined,
            weekday: "long",
        });
    };

    useEffect(() => {
        if (type === "flight") {
            const { departure, destination, departureDate, returnDate, personCounter } = information || {};
            const personCount = personCounter?.totalPersons;

            if (locale === "fa") {
                setHeaderTitle(`${departure?.name} به ${(destination?.name || destination?.english_name) ?? ""}`);
                setHeaderDetails(`${formatDate(departureDate)} ${returnDate ? `تا ${formatDate(returnDate)}` : ""} - ${personCount} نفر`);
            }
            if (locale === "ar") {
                setHeaderTitle(`${departure?.name} الی ${destination?.name ?? ""}`);
                setHeaderDetails(
                    `${formatDateWithArabicMonth(departureDate)} ${
                        returnDate ? `حتى ${formatDateWithArabicMonth(returnDate)}` : ""
                    } - ${personCount} ${personCount > 1 ? "أشخاص" : "شخص"}`,
                );
            } else if (locale === "en") {
                setHeaderTitle(`${departure?.english_name} to ${destination?.english_name ?? ""}`);
                setHeaderDetails(`${formatGregorianDate(departureDate, returnDate, "D MMM")} - ${personCount} person${personCount > 1 ? "s" : ""}`);
            }
        }
        if (type === "bus") {
            const { departure, destination, departureDate } = information || {};

            if (locale === "fa") {
                setHeaderTitle(`${departure?.name} به ${(destination?.name || destination?.english_name) ?? ""}`);
                setHeaderDetails(`${formatDate(departureDate)}`);
            }
            if (locale === "ar") {
                setHeaderTitle(`${departure?.name} الی ${destination?.name ?? ""}`);
                setHeaderDetails(`${formatDateWithArabicMonth(departureDate)}`);
            } else if (locale === "en") {
                setHeaderTitle(`${departure?.english_name} to ${destination?.english_name ?? ""}`);
                setHeaderDetails(`${formatGregorianDate(departureDate, null, "D MMM")}`);
            }
        }
        if (type === "hotel") {
            const { destination, checkIn, checkOut } = information || {};
            const nightsCount = calculateDateDifferenceInDays(checkIn, checkOut);
            if (locale === "fa") {
                setHeaderTitle(destination?.name);
                setHeaderDetails(`${formatDate(checkIn)} تا ${formatDate(checkOut)} - ${nightsCount} شب`);
            }
            if (locale === "ar") {
                setHeaderTitle(destination?.name);
                setHeaderDetails(`${formatDateWithArabicMonth(checkIn)} حتى ${formatDateWithArabicMonth(checkOut)} - ${nightsCount} الليل`);
            } else if (locale === "en") {
                setHeaderTitle(destination?.english_name);
                setHeaderDetails(`${formatGregorianDate(checkIn, checkOut, "D MMM")} - ${nightsCount} nights`);
            }
        }

        if (type === "bus") {
            const { departure, destination, departureDate } = information || {};
            if (locale === "fa") {
                setHeaderTitle(`${departure?.name} به ${(destination?.name || destination?.english_name) ?? ""}`);
                setHeaderDetails(`${formatDate(departureDate)} `);
            }
            if (locale === "ar") {
                setHeaderTitle(`${departure?.name} الی ${destination?.name ?? ""}`);
                setHeaderDetails(`${formatDateWithArabicMonth(departureDate)}`);
            } else if (locale === "en") {
                setHeaderTitle(`${departure?.english_name} to ${destination?.english_name ?? ""}`);
                setHeaderDetails(`${formatGregorianDate(departureDate)}`);
            }
        }
    }, [information, locale, type]);

    return { headerTitle, headerDetails };
};

export default useHeaderInfo;
